export function validateVisit(values) {
  const errors = {};
  if (!values.date) errors.date = "** Required **";
  if (values.township_ids.length == 0) errors.township_ids = "** Required **";
  if (!values.type_of_visit) errors.type_of_visit = "** Required **";
  if (values.type_of_visit==1 && !values.place_of_visit) errors.place_of_visit = "** Required **";

  return errors;
}
